import React from "react";
import { Select, MenuItem, SelectChangeEvent, Button } from "@mui/material";
import { LABELS, STATUS_OPTIONS } from "./OrderSummaryConstants";

interface OrderStatusSelectorProps {
  status: string;
  orderStatus?: string;
  remainingAmount?: number;
  isFullyPaid?: boolean;
  onChange: (event: SelectChangeEvent<string>) => void;
  onDeliveredClick?: () => void;
}

const OrderStatusSelector: React.FC<OrderStatusSelectorProps> = ({ status, orderStatus, remainingAmount, isFullyPaid, onChange, onDeliveredClick }) => {
  const getFilteredStatusOptions = () => {
    if (orderStatus === "Cancelled") {
      return [];
    }

    if (isFullyPaid || (remainingAmount !== undefined && remainingAmount <= 0)) {
      return ["Delivered"];
    }

    if (remainingAmount && remainingAmount > 0) {
      return STATUS_OPTIONS.filter((option) => option !== "Delivered");
    }

    return STATUS_OPTIONS;
  };

  const filteredOptions = getFilteredStatusOptions();

  const showDeliveredButton = (isFullyPaid || remainingAmount === 0) && status !== "Delivered" && orderStatus !== "Cancelled" && orderStatus !== "Delivered";

  if (orderStatus === "Cancelled") {
    return (
      <div className="mb-4">
        <p className="order-status-container">{LABELS.ORDER_STATUS}</p>
        <div className="order-status-canceled">{LABELS.CANCELED}</div>
      </div>
    );
  }

  if (orderStatus === "Delivered" || status === "Delivered") {
    return (
      <div className="mb-4">
        <p className="order-status-container">{LABELS.ORDER_STATUS}</p>
        <div className="order-status-delivered bg-green-100 text-green-800 p-2 rounded font-semibold">Delivered</div>
      </div>
    );
  }

  return (
    <div className="mb-4">
      <p className="order-status-container">{LABELS.ORDER_STATUS}</p>
      <div className="space-y-2">
        {filteredOptions.length > 0 && !showDeliveredButton && (
          <Select id="order-status" value={status} fullWidth disabled={status === "Delivered" || orderStatus === "Delivered"} onChange={onChange} className="order-status-select">
            {filteredOptions.map((s) => (
              <MenuItem key={s} value={s}>
                {s}
              </MenuItem>
            ))}
          </Select>
        )}

        {showDeliveredButton && (
          <Button variant="contained" color="success" fullWidth onClick={onDeliveredClick} className="bg-green-600 hover:bg-green-700">
            Mark as Delivered
          </Button>
        )}
      </div>
    </div>
  );
};

export default OrderStatusSelector;
